"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoaggloService = void 0;
var _maplibreGl = require("maplibre-gl");
var _models = require("../models");
var _app = require("./app");
var _http = require("./http");
var _photo = require("./photo");
class GeoaggloService {
  static async getGeoagglos({
    query
  } = {}) {
    try {
      const res = await _http.HttpService.get('v2', `/geoagglos`, query ? [{
        key: 'query',
        value: query
      }] : undefined);
      const geoagglos = res.map(data => parseGeoagglo(data, _app.AppService.environment.backendUrl));
      return geoagglos;
    } catch (err) {
      console.error('[GeoaggloService][getGeoagglos]', err);
      throw err;
    }
  }
  static async getHighlights(geoaggloId) {
    try {
      const res = await _http.HttpService.get('v2', `/highlights`, [{
        key: 'geoagglo_id',
        value: geoaggloId
      }]);
      const highlights = res.map(data => parseGeoaggloHighlight(data, _app.AppService.environment.backendUrl));
      return highlights;
    } catch (err) {
      console.error('[GeoaggloService][getHighlights]', err);
      throw err;
    }
  }
}
exports.GeoaggloService = GeoaggloService;
function parseGeoagglo({
  id,
  code,
  area,
  bounds: _bounds,
  geo_center,
  long_name,
  logo,
  logo_alt,
  photo,
  has_bss,
  importance
}, backendUrl) {
  let bounds = null;
  let center = geo_center;
  if (_bounds) {
    const [west, south, east, north] = _bounds;
    bounds = {
      north,
      east,
      south,
      west
    };
    if (!center) {
      const {
        lat,
        lng
      } = new _maplibreGl.LngLatBounds({
        lat: south,
        lng: west
      }, {
        lat: north,
        lng: east
      }).getCenter();
      center = {
        type: 'Point',
        coordinates: [lng, lat]
      };
    }
  }
  return new _models.Geoagglo(id, code, area, bounds, center, long_name, logo ? `${backendUrl}${logo}` : null, logo_alt ? `${backendUrl}${logo_alt}` : null, photo ? {
    url: `${backendUrl}${photo}`,
    squaredThumbnailUrl: `${backendUrl}${photo.replace('large', 'thumbnail')}`
  } : null, has_bss, importance || 0);
}
function parseGeoaggloHighlight({
  id,
  title,
  description,
  photo,
  ride,
  rideset,
  poi
}, backendUrl) {
  return new _models.GeoaggloHighlight(id, title, description, photo ? (0, _photo.parsePhoto)(photo, backendUrl) : null, null, false, ride, rideset, poi);
}